<template>
  <ListingLayout
    :is-loading="isLoading"
    :meta="meta"
    :headers="headers"
    :items="list"
    no-filters
    :filter-names="[]"
    @filterOption="onFiltersChange"
    @clickOnRow="whenRowSelect"
  >
    <template v-slot:start_datetime="{ item }">
      <div>
        {{ item.start_datetime | formatDate }}
      </div>
    </template>
    <template v-slot:end_datetime="{ item }">
      <div>
        {{ item.end_datetime | formatDate }}
      </div>
    </template>
    
    <template v-slot:booking_status="{ item }">
      <div>
        <status-badge
          :status="item.booking_status"
          :text="item.booking_status"
        />
      </div>
    </template>
    <!-- asdadasd
  <v-data-table
    :loading="isLoading"
    :headers="headers"
    :items="list"
    :items-per-page="5"
  /> -->
  </ListingLayout>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    StatusBadge: () => import("@/components/base/Status-Badge.vue"),
  },
  mixins: [ListingLayoutMixins],
  data() {
    return {
      headers: [
        {
          text: "id",
          align: "start",
          sortable: true,
          value: "id",
        },
        {
          text: "Location",
          align: "start",
          sortable: false,
          value: "location",
        },
        {
          text: "Charge Point ID",
          align: "start",
          sortable: false,
          value: "charge_point_id",
        },
        {
          text: "Maintenance Type",
          align: "start",
          sortable: true,
          value: "maintenance_type",
        },
        {
          text: "Start Datetime",
          align: "start",
          sortable: true,
          value: "start_datetime",
        },
        {
          text: "End Datetime",
          align: "start",
          sortable: true,
          value: "end_datetime",
        },
        {
          text: "Maintenance Description",
          align: "start",
          sortable: true,
          value: "description",
        },
       
        // {
        //   text: "Actions",
        //   align: "start",
        //   sortable: false,
        //   value: "user",
        // },
      ],
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "chargerMaintaince/getLoading",
      list: "chargerMaintaince/getList",
    }),
    meta() {
      return {
        page: 1,
        itemsPerPage: 10000,
        lastPage: 1,
        totalItems: this.list?.length,
      };
    },
  },
  methods: {
    whenRowSelect(v) {
      this.$emit("clickOnRow", v);
    },
  },
};
</script>
